var _linearGradient, _linearGradient2, _path, _path2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10, _linearGradient10, _path11, _linearGradient11, _path12, _linearGradient12, _path13, _linearGradient13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountingJournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: -7642.318,
    y1: -968.737,
    x2: -7641.318,
    y2: -968.737
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 29.016,
    y1: 56.423,
    x2: 65.296,
    y2: 56.423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.641 56.423h35.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M48.142 18.506s-.384-2.221-2.221-2.221c-1.838 0-2.331 2.221-2.331 2.221l4.772 3.618M43.809 22.124s.384 2.221 2.221 2.221c1.838 0 2.331-2.221 2.331-2.221M45.976 14.392v1.893M45.976 24.346v1.892"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M64.671 56.423V4.788H23.765v6.041M23.765 27.599v-4.016M23.765 44.298v-3.77M23.765 56.423v-7.665M23.765 36.069v-4.011M23.765 19.124v-3.836"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 19.704,
    y1: 21.353,
    x2: 27.246,
    y2: 21.353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 21.351c0 .87-1.463 2.26-3.265 2.26-1.808 0-3.027-1.012-3.027-2.26 0-1.242 1.219-2.254 3.027-2.254 1.802-.001 3.265 1.387 3.265 2.254z",
    fill: "none",
    stroke: "url(#SVGID_2_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 19.704,
    y1: 13.061,
    x2: 27.246,
    y2: 13.061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 13.058c0 .87-1.463 2.26-3.265 2.26-1.808 0-3.027-1.012-3.027-2.26 0-1.242 1.219-2.254 3.027-2.254 1.802 0 3.265 1.387 3.265 2.254z",
    fill: "none",
    stroke: "url(#SVGID_3_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 19.704,
    y1: 29.827,
    x2: 27.246,
    y2: 29.827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 29.824c0 .87-1.463 2.26-3.265 2.26-1.808 0-3.027-1.012-3.027-2.26 0-1.242 1.219-2.254 3.027-2.254 1.802 0 3.265 1.388 3.265 2.254z",
    fill: "none",
    stroke: "url(#SVGID_4_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 19.704,
    y1: 38.301,
    x2: 27.246,
    y2: 38.301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 38.298c0 .87-1.463 2.26-3.265 2.26-1.808 0-3.027-1.012-3.027-2.26 0-1.242 1.219-2.254 3.027-2.254 1.802 0 3.265 1.388 3.265 2.254z",
    fill: "none",
    stroke: "url(#SVGID_5_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 19.704,
    y1: 46.528,
    x2: 27.246,
    y2: 46.528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 46.525c0 .87-1.463 2.26-3.265 2.26-1.808 0-3.027-1.012-3.027-2.26 0-1.242 1.219-2.254 3.027-2.254 1.802 0 3.265 1.387 3.265 2.254z",
    fill: "none",
    stroke: "url(#SVGID_6_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 25.996,
    y1: 17.204,
    x2: 29.058,
    y2: 17.204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 21.351s4.078-4.214 0-8.292",
    fill: "none",
    stroke: "url(#SVGID_7_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 25.996,
    y1: 8.915,
    x2: 29.058,
    y2: 8.915
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 13.061s4.078-4.214 0-8.292",
    fill: "none",
    stroke: "url(#SVGID_8_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 25.996,
    y1: 25.681,
    x2: 29.058,
    y2: 25.681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 29.827s4.078-4.214 0-8.292",
    fill: "none",
    stroke: "url(#SVGID_9_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 25.996,
    y1: 34.157,
    x2: 29.058,
    y2: 34.157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 38.304s4.078-4.214 0-8.292",
    fill: "none",
    stroke: "url(#SVGID_10_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 25.996,
    y1: 42.447,
    x2: 29.058,
    y2: 42.447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.621 46.593s4.078-4.214 0-8.292",
    fill: "none",
    stroke: "url(#SVGID_11_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843",
    gradientUnits: "userSpaceOnUse",
    x1: 25.997,
    y1: 49.923,
    x2: 29.057,
    y2: 49.923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.622 46.525l.033.033c2.533 2.566 1.86 5.182 1.012 6.763",
    fill: "none",
    stroke: "url(#SVGID_12_a1214c9d5937a69ca2ef6262e8c4040f0e510a8f427785e780ae3d259ec6d843)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M64.668 53.32H26.869a3.114 3.114 0 00-3.105 3.105 3.114 3.114 0 003.105 3.105h37.799v-6.21zM48.635 29.827h-5.319c-5.231 0-9.512-4.28-9.512-9.512 0-5.231 4.28-9.512 9.512-9.512h5.319c5.231 0 9.512 4.28 9.512 9.512s-4.28 9.512-9.512 9.512z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingJournal);
export default __webpack_public_path__ + "static/media/accountingJournal.a677bcc7cc08605dc5186080b2c0a488.svg";
export { ForwardRef as ReactComponent };